import React, { useMemo, useState, useEffect } from 'react';
import { Modal, Button } from 'antd';
import CreateBookCreditForm from 'src/pages/Credits/CreateBookCreditForm';
import { GET_USER_INFO } from 'src/operations/queries/campus';
import { GET_BOOK_CREDIT_LIST } from 'src/operations/queries/bookCredit';
import { GET_COMPANY_CAMPUS_AND_CONTENTS } from 'src/operations/queries/company';
import { CREATE_BOOK_CREDIT } from 'src/operations/mutations/bookCredit';
import { useLazyQuery, useQuery, useMutation } from '@apollo/client';
import { openNotification } from 'src/components/common/Notification';

const CreateBookCreditModal = ({ visible, onClose }) => {
  const [isCreated, setIsCreated] = useState(false);
  const { data: dataUser } = useQuery(GET_USER_INFO);
  const { data: dataCompany } = useQuery(GET_COMPANY_CAMPUS_AND_CONTENTS, {
    skip: !dataUser,
    variables: {
      company_idx: dataUser?.getUserData.campus.fc_company_idx,
    },
  });
  const [getBookCreditList, { data: dataBookCredit }] = useLazyQuery(GET_BOOK_CREDIT_LIST);
  const bookCreditList = useMemo(() => {
    if (dataBookCredit) {
      return dataBookCredit.getBookCreditList.map((item, key) => {
        return { ...item, key: `book-credit-list${key}` };
      });
    }
    return [];
  }, [dataBookCredit]);

  const [createBookCredit, { loading: loadingCreate }] = useMutation(CREATE_BOOK_CREDIT, {
    onCompleted: () => {
      openNotification('발급 완료!');
      setIsCreated(true);
    },
    onError(error) {
      alert('error');
      console.log('error', error);
    },
  });

  const handleChangeCampus = (value) => {
    getBookCreditList({ variables: { campus_idx: parseInt(value) } });
  };
  const handleRegister = (values) => {
    const { book_code, campus_idx, book_count } = values;
    const book_credit_input = {
      campus_idx,
      book_code,
      credit_count: book_count,
      credit_type: '2', //create manually
    };
    createBookCredit({
      variables: { book_credit_input },
      refetchQueries: [
        {
          query: GET_BOOK_CREDIT_LIST,
          variables: { campus_idx },
        },
      ],
    });
  };
  const handleClose = () => {
    onClose(isCreated);
  };

  useEffect(() => {
    if (visible) {
      setIsCreated(false);
    }
  }, [visible]);

  return (
    <Modal
      visible={visible}
      title="이용권 발급"
      onCancel={handleClose}
      width={`${80}%`}
      footer={[
        <Button key="back" onClick={handleClose}>
          닫기
        </Button>,
      ]}
    >
      <CreateBookCreditForm
        campusList={dataCompany?.getCampusList}
        contentList={dataCompany?.getCompanyBookContentList}
        bookCreditList={bookCreditList}
        onChangeCampus={handleChangeCampus}
        onRegister={handleRegister}
        loadingCreate={loadingCreate}
      />
    </Modal>
  );
};

export default CreateBookCreditModal;
